import { createAction } from 'redux-actions';
import { Language } from '@eta/components';
import { LOAD_REFERENCE_DATA } from './Types';
import { ProfileManagementService } from '../../Services/ProfileManagement/Service';
import { LookupsDto, GetLookupResponse } from '../../Services/ClientProxy/clientProxy';

const profileManagementService = new ProfileManagementService();
// TypeScript infers that this function is returning SendMessageAction

export const loadReferenceData = createAction(LOAD_REFERENCE_DATA, async (lang: Language) => {
    try {
        const taxpayersConfig = await profileManagementService.getTaxpayersConfig(lang);
        if (!taxpayersConfig.countries) {
            taxpayersConfig.countries = [];
        }
        taxpayersConfig.countries.splice(0, 0, new LookupsDto({ id: -1, code: '', name: '', parentCode: '' }));
        return {
            taxPayersConfig: taxpayersConfig,
        };
    } catch (ex) {
        return {
            taxPayersConfig: new GetLookupResponse()
        };
    }
});
